export default {
  totaisVendasProdutos: {},
  totaisVendasProdutosTop: {},
  produtosMaisVendidosTop: {},
  totaisFaturamentoProdutos: {},
  totaisFaturamentoProdutosTop: {},
  produtosMaisFaturadosTop: {},
  totaisCuponsProdutos: {},
  totaisCuponsProdutosTop: {},
  produtosMaisCuponsTop: {},
  totaisClientesProdutos: {},
  totaisClientesProdutosTop: {},
  produtosMaisClientesTop: {},
  precoMedio: {},
  mediaItens: {},
  quantidadeCesta: {},
  horasMaioresCompras: [],
  diasMaioresCompras: [],
  diasSemanaMaioresCompras: [],
  mpp: [],
  productsTree: [],
  categoriesTree: [],
  measureUnits: [],
}
